import StaticTable from '@api-consent/util/StaticTable';
import data from './lifecycleRaw';

export default new StaticTable(data);
